var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/toggleCameraFace.f8c05fe0.png","uri@2x": __webpack_public_path__ + "static/media/toggleCameraFace.6113ef80.png","uri@3x": __webpack_public_path__ + "static/media/toggleCameraFace.d4bb6e74.png",
    width: 39,
    height: 38
});